export const multiplyMatrixAndPoint = (matrix, point) => {
	const c0r0 = matrix[0];
	const c1r0 = matrix[1];
	const c0r1 = matrix[2];
	const c1r1 = matrix[3];
	const x = point[0];
	const y = point[1];
	return [
		Math.abs(x * c0r0 + y * c0r1),
		Math.abs(x * c1r0 + y * c1r1),
	];
};

export default multiplyMatrixAndPoint;
